// A workaround for Quill bug related to copy/cut-pasting embedded objects with
// child nodes. See https://github.com/quilljs/quill/issues/3006
export const copyEmbedBlotWorkaround = (quillRef, $event, cutting) => {
  const quill = quillRef.current;

  if (!quill) {
    return null;
  }

  let [range] = quill.selection.getRange();
  let { ops } = quill.getContents(range);

  // Sometimes range.length is 0 even if there's a visible selection
  // Side effect is that embed gets copied if cursor is positioned just before it
  // and copy/cut action is performed
  if (ops.length === 0 && range.length === 0) {
    range = { ...range, length: 1 };
    ops = quill.getContents(range).ops;
  }

  // Check if selection is custom-attribute and that only
  if (ops && ops.length === 1 && ops[0].insert.customVariable !== undefined) {
    const { customVariable } = ops[0].insert;

    // Compose minimun viable node to carry custom-variable data
    $event.clipboardData.setData(
      'text/html',
      `
        <span class="custom-variable-blot" data-value="${customVariable}"><span contenteditable="false">%{${customVariable}}</span></span>
        `,
    );

    // Add plain text to allow copying outside of Quill
    $event.clipboardData.setData('text/plain', customVariable);

    if (cutting) {
      // Must delete manually here because default event handling is prevented
      quill.deleteText(range.index, range.length, 'user');
    }

    $event.preventDefault();
  }

  // Add other custom embeds here...
};
